import React from "react";
import PropTypes from "prop-types";
import { STAKING_STATUS } from "constants/stake";
import { getStakingStatusLabel } from "utils/stake";
import { StyledStatusTag } from "./styles";

const VARIANT_STYLES = {
  [STAKING_STATUS.REDEEMED]: {
    background: "#16A2491A",
    color: "#16A249",
  },
  [STAKING_STATUS.HOLDING]: {
    background: "#4E7CDF1A",
    color: "#3765C6",
  },
  [STAKING_STATUS.CLAIMED]: {
    background: "#0000001A",
    color: "#000000",
  },
  [STAKING_STATUS.CLAIM_FAILED]: {
    background: "#EE2B2B1A",
    color: "#EE3424",
  },
  [STAKING_STATUS.CLAIM_IN_PROGRESS]: {
    background: "#F3850F1A",
    color: "#A85905",
  },
  [STAKING_STATUS.PENDING]: {
    background: "#F3850F1A",
    color: "#A85905",
  }
};

export const STATUS_TAG_VARIANTS = Object.keys(VARIANT_STYLES);

export const StatusTag = ({
  status,
  className,
  ...rest
}) => {

  const statusLabel = getStakingStatusLabel(status);
  const variant = VARIANT_STYLES[status] || VARIANT_STYLES[STAKING_STATUS.HOLDING]; 

  return <StyledStatusTag $background={variant.background} $color={variant.color} className={className} {...rest}>{statusLabel}</StyledStatusTag>;
};

StatusTag.propTypes = {
  variant: PropTypes.oneOf([
    STAKING_STATUS.PENDING,
    STAKING_STATUS.HOLDING,
    STAKING_STATUS.CLAIMED,
    STAKING_STATUS.CLAIM_FAILED,
    STAKING_STATUS.REDEEMED,
  ]),
  className: PropTypes.string,
};
